import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useFetch, usePromise } from '@rad/hooks';
import { getPublicTourSummary } from '../../../../common/network/tour';
// What a tour's page says to a visitor when the tour is not live: one not published yet, or one that
// is over, by name. A link printed or posted before then still lands somewhere that makes sense.
const TourClosed = (props) => {
    const [summaryPromise] = useFetch(getPublicTourSummary(props.tourId));
    const summary = usePromise(summaryPromise);
    const message = summary === undefined ? ''
        : summary === null ? 'This tour is not available.'
            : summary.status === 'archived' ? `${summary.title} has ended.`
                : summary.status === 'draft' ? `${summary.title} isn't open yet.`
                    : 'This tour is not available.';
    return _jsx(_Fragment, { children: _jsx("div", { className: "container py-5 text-center text-muted", "aria-busy": summary === undefined, children: message }) });
};
export default TourClosed;
